import { render, staticRenderFns } from "./QuotationRiskForm.vue?vue&type=template&id=4b37a0f3"
import script from "./QuotationRiskForm.vue?vue&type=script&lang=js"
export * from "./QuotationRiskForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationRiskForm.vue?vue&type=style&index=0&id=4b37a0f3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports